import React from "react";
import CardWithHeader from "../../../../common/components/card/card-with-header";
import {STATUSES} from "./dot-inspection-config";
import DotInspectionItemRow from "./dot-inspection-item-row";
import DotInspectionMeasurementTable from "./dot-inspection-measurement-table";

export default function DotInspectionSectionCard({
                                                      section,
                                                      answers,
                                                      onItemChange,
                                                      onSectionSetAll,
                                                      tireRows,
                                                      brakeRows,
                                                      onTireRowChange,
                                                      onAddTireRow,
                                                      onRemoveTireRow,
                                                      onBrakeRowChange,
                                                      onAddBrakeRow,
                                                      onRemoveBrakeRow,
                                                      translate
                                                  }) {
    return (
        <CardWithHeader
            title={translate(section.titleKey)}
            afterTitle={
                <div className="flex flex-wrap items-center gap-1.5">
                    {STATUSES.map((it) => (
                        <button
                            key={it.key}
                            type="button"
                            onClick={() => onSectionSetAll(section.id, it.key)}
                            className="rounded-btn px-2.5 py-1 text-xs font-medium ring-1 ring-inset bg-inverse text-tm-gray-600 ring-tm-gray-300 hover:bg-tm-gray-100"
                        >
                            {translate(it.labelKey)}
                        </button>
                    ))}

                    <button
                        type="button"
                        onClick={() => onSectionSetAll(section.id, null)}
                        className="px-2 text-xs font-medium text-tm-gray-500 hover:text-tm-gray-700"
                    >
                        {translate('btn.dot_clear')}
                    </button>
                </div>
            }
        >
            <div className="divide-y divide-tm-gray-200">
                {section.items.map((item) => (
                    <DotInspectionItemRow
                        key={item.id}
                        item={item}
                        status={answers[item.id]}
                        onChange={onItemChange}
                        translate={translate}
                    />
                ))}
            </div>

            {section.extra === 'tires' && (
                <DotInspectionMeasurementTable
                    type="tire"
                    rows={tireRows}
                    onRowChange={onTireRowChange}
                    onAddRow={onAddTireRow}
                    onRemoveRow={onRemoveTireRow}
                    translate={translate}
                />
            )}

            {section.extra === 'brakes' && (
                <DotInspectionMeasurementTable
                    type="brake"
                    rows={brakeRows}
                    onRowChange={onBrakeRowChange}
                    onAddRow={onAddBrakeRow}
                    onRemoveRow={onRemoveBrakeRow}
                    translate={translate}
                />
            )}
        </CardWithHeader>
    );
}
